<template src="./Filter.html"></template>
<style src="./Filter.css" ></style>

<script>
import moment from "moment";

import store from "@/store/index.js";
import { getAcessoRealtec } from "@/services/modules/acessoRealtec.js";

import PasswordDlg from "@/components/AcessoRealtec/Password/Password";

moment.locale("pt-BR");

export default {
  components: {
    "app-components-acesso-realtec-password": PasswordDlg
  },

  data() {
    return {
      somenteUsuarioLogado: true,
      dateOne: new Date(/*moment().startOf("year")*/),
      dateTwo: new Date(/*moment().endOf("month")*/),
      showingDatePicker: false,
      situacao: 9,
      situacoes: [
        {
          value: 0,
          text: "Aguardando"
        },
        {
          value: 1,
          text: "Aguardando e autorizado"
        },
        {
          value: 2,
          text: "Autorizado"
        },
        {
          value: 3,
          text: "Encerrado"
        },        
        {
          value: 4,
          text: "Negado"
        },
        {
          value: 9,
          text: "Todos"
        }
      ],
      cliente: null,
      passwordDialog: false,
      todaySearch: true
    };
  },
  created() {    
    refresh();
  },
  methods: {
    showHideDatePicker() {
      this.showingDatePicker = !this.showingDatePicker;
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = "";

      this.todaySearch = false;

      if (this.dateOne) {
        formattedDates = `${moment(this.dateOne).format("DD")} ${moment(
          this.dateOne
        ).format("MMMM")}`;
      }

      if (this.dateTwo) {
        formattedDates += ` até ${moment(this.dateTwo).format("DD")} ${moment(
          this.dateTwo
        ).format("MMMM")}`;
      }

      if (this.dateOne && this.dateTwo && (this.dateOne == this.dateTwo) && (moment(new Date()).format("YYYY-MM-DD") == this.dateOne)){
        formattedDates = "Hoje";
        this.todaySearch = true;
      }

      if (formattedDates == "") return "Nenhum período selecionado";

      return formattedDates;
    },
    getDateFilter() {
      if (this.dateOne == "" && this.dateTwo == "") return {};

      let initialDate = null;
      let finalDate = null;
      if (this.dateOne != null && this.dateOne != "")
        initialDate = moment(this.dateOne).format("YYYY-MM-DD");
      if (this.dateTwo != null && this.dateTwo != "")
        finalDate = moment(this.dateTwo).format("YYYY-MM-DD");

      return {
        acRealRequisicaoIni: initialDate,
        acRealRequisicaoFim: finalDate
      };
    },
    refresh() {
      if (this.todaySearch){
        this.dateOne = new Date();
        this.dateTwo = new Date();
      }

      this.applyFilter();
    },
    include() {

    },
    generatePass() {
      this.passwordDialog = true;
    },
    closePassDialog(snackbar) {
      this.passwordDialog = false;
    },    
    applyDateFilter() {
      this.applyFilter();
    },
    cancelDateFilter() {},
    applyFilter() {
      let usuCodigo = undefined
      let cliCodigo = undefined;
      if(this.somenteUsuarioLogado) usuCodigo = this.user.USUCODIGO
      if (this.cliente) cliCodigo = this.cliente.CLICODIGO;
      const { acRealRequisicaoIni, acRealRequisicaoFim } = this.getDateFilter();
      const acRealSituacao = this.situacao;

      getAcessoRealtec({
        cliCodigo,
        acRealRequisicaoIni,
        acRealRequisicaoFim,
        acRealSituacao,
        usuCodigo
      });
    }
  },
  computed: {
    isXs() {
      return store.state.window.isXs;
    },
    windowWidth() {
      return store.state.window.width;
    },
    user(){      
      return store.state.user.data
    },
    data() {
      return store.state.acessoRealtec.data;
    },
    isLoadingData() {
      return store.state.acessoRealtec.loadingData;
    },
    isLoadingClientes() {
      return store.state.acessoRealtec.loadingClientesData;
    },
    clientes() {
      return store.state.acessoRealtec.clientesData;
    }
  },
  watch: {
    somenteUsuarioLogado(){
      this.applyFilter();
    },
    situacao() {
      this.applyFilter();
    },
    cliente() {
      this.applyFilter();
    }
  }
};
</script>